import { render, staticRenderFns } from "./AttachmentField.vue?vue&type=template&id=20623dce&scoped=true&"
import script from "./AttachmentField.vue?vue&type=script&lang=js&"
export * from "./AttachmentField.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentField.vue?vue&type=style&index=0&id=20623dce&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20623dce",
  null
  
)

export default component.exports